import * as React from 'react';

import {FlashBanner} from '../../flash-banner/flash-banner';

type Props = {
    error: string;
    setError: (error?: string | null | undefined) => void;
};

export function WidgetErrorBanner(props: Props) {
    return (
        <FlashBanner
            type='error'
            duration={5000}
            onHidden={() => props.setError(null)}
            hasBorder={true}
            childrenClassName='font-size-small'
        >
            {props.error}
        </FlashBanner>
    );
}
